import { useMutation } from '@tanstack/react-query';
import { translationService, type TranslateRequest } from '../services/translation.service';

export function useTranslateText() {
  return useMutation({
    mutationFn: (request: TranslateRequest) =>
      translationService.translateText(request),
  });
}
